/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { QUESTION } from '../../constants/terminology';

const CompleteSignUp = () => {

  return <>
    <div className='onboarding-form'>
      <section className='title-container'>
        <div className='h1'>Almost done!</div>
        <div className='h1 mb-3'>We've loaded the sustainability survey</div>
        <p>Answering these {QUESTION.PLURAL} means you can show impact <br />towards your ESG goals, as well as <br /> the UN Sustainable Development Goals (SDGs)</p>

        <div className='border-top border-ThemeBgDisabled mt-4 pt-4 h1'>
          <i className='fa fa-envelope mr-2' />
          Now confirm your e-mail address
        </div>
        <p>Please click on the link in the email we've sent, to activate your account.</p>
      </section>
    </div>
  </>;
}

export default CompleteSignUp;
